import { ActionTree } from 'vuex'

import { UserState, RootState } from '@/types/store'

import { getMe, login } from '@/api/users'

import router from '@/router'

type LoginInput = {
  code: string
  password: string
}

export const actions: ActionTree<UserState, RootState> = {
  async login({ dispatch }, loginInput: LoginInput): Promise<void> {
    try {
      const { accessToken, ip } = await login(
        loginInput.code,
        loginInput.password,
      )
      localStorage.setItem('jwtToken', accessToken)
      localStorage.setItem('ip', ip)
      await dispatch('getMe')
    } catch (error) {
      return Promise.reject('invalid code or password')
    }
  },
  async getMe({ commit }): Promise<void> {
    const me = await getMe()
    commit('getMe', me)
  },
  logout({ commit }): void {
    localStorage.setItem('jwtToken', '')
    commit('logout')
    router.push('/login').catch(() => {
      /*2連打した際のerrorを無視*/
    })
  },
}
